/**
 * @generated SignedSource<<185ec2b42412d11a5ce848585b84e689>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RsAddToRateCardDialogRateCardMutation$variables = {
  existingRateCardId?: string | null;
  newRateCardName?: string | null;
  only: ReadonlyArray<string | null>;
};
export type RsAddToRateCardDialogRateCardMutation$data = {
  readonly saveSearchesToRateCard: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
    } | null> | null;
    readonly rateCard: {
      readonly createdDate: string;
      readonly id: string;
      readonly locationCount: number | null;
      readonly name: string | null;
      readonly owner: {
        readonly email: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly termsOfAgreement: boolean;
        readonly userId: number;
      };
      readonly ratecardId: number;
      readonly searchCount: number | null;
      readonly shared: boolean;
      readonly tags: ReadonlyArray<{
        readonly name: string;
        readonly tagId: number;
      } | null> | null;
      readonly updateDate: string;
    } | null;
  } | null;
};
export type RsAddToRateCardDialogRateCardMutation = {
  response: RsAddToRateCardDialogRateCardMutation$data;
  variables: RsAddToRateCardDialogRateCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "existingRateCardId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newRateCardName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "only"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "existingRatecard",
        "variableName": "existingRateCardId"
      },
      {
        "kind": "Literal",
        "name": "filters",
        "value": {}
      },
      {
        "kind": "Variable",
        "name": "newRatecard",
        "variableName": "newRateCardName"
      },
      {
        "kind": "Variable",
        "name": "only",
        "variableName": "only"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ratecardId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shared",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tagId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "LegacyUserNode",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termsOfAgreement",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updateDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RsAddToRateCardDialogRateCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveSearchesToRateCardPayload",
        "kind": "LinkedField",
        "name": "saveSearchesToRateCard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RateCardsNode",
            "kind": "LinkedField",
            "name": "rateCard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TagNode",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RsAddToRateCardDialogRateCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveSearchesToRateCardPayload",
        "kind": "LinkedField",
        "name": "saveSearchesToRateCard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RateCardsNode",
            "kind": "LinkedField",
            "name": "rateCard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TagNode",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b570f2af4e40ef3fe5d8763e7730e3c5",
    "id": null,
    "metadata": {},
    "name": "RsAddToRateCardDialogRateCardMutation",
    "operationKind": "mutation",
    "text": "mutation RsAddToRateCardDialogRateCardMutation(\n  $existingRateCardId: String\n  $newRateCardName: String\n  $only: [String]!\n) {\n  saveSearchesToRateCard(input: {only: $only, filters: {}, existingRatecard: $existingRateCardId, newRatecard: $newRateCardName}) {\n    errors {\n      __typename\n    }\n    rateCard {\n      ratecardId\n      id\n      shared\n      tags {\n        name\n        tagId\n        id\n      }\n      owner {\n        firstName\n        lastName\n        email\n        userId\n        termsOfAgreement\n      }\n      name\n      createdDate\n      updateDate\n      searchCount\n      locationCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "70e93c3c897f8319f2c44c79969e525e";

export default node;
